// Client time base and frame timing (§23.2).
import { TICK_HZ } from '@shared/constants';

/** Milliseconds per sim tick. */
export const TICK_MS = 1000 / TICK_HZ;
/** Longest frame step the client simulates/animates, in seconds. */
export const MAX_FRAME_DT = 0.1;

/** Monotonic milliseconds (performance.now). */
export function now(): number {
  return performance.now();
}

/** Per-frame delta: `dt = min(0.1, (now − last) / 1000)` seconds; 0 on the first frame. */
export class FrameTimer {
  private last = -1;

  frame(t: number = now()): number {
    const dt = this.last < 0 ? 0 : Math.min(MAX_FRAME_DT, Math.max(0, (t - this.last) / 1000));
    this.last = t;
    return dt;
  }

  reset(): void {
    this.last = -1;
  }
}
